import { render } from "./SettingTransaction.vue?vue&type=template&id=343b7cba&scoped=true"
import script from "./SettingTransaction.vue?vue&type=script&lang=js"
export * from "./SettingTransaction.vue?vue&type=script&lang=js"

import "./SettingTransaction.vue?vue&type=style&index=0&id=343b7cba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343b7cba"]])

export default __exports__